module.exports = __webpack_public_path__ + "img/compo-vic.45a9e55f.png";